import React, { useEffect, useState } from "react";
import { Footer } from "dstill";
import FooterMock from "./footer-params-mock";
import { FooterState } from "./ContentTypes";
import { useContentful } from "../../utils/hooks/contentful/useContentful";
import { useLocale } from "../../utils/hooks/locale/useLocale";
import { trackItem } from "../../utils/hooks/useSegment";
import useSize from "../../utils/hooks/useSize";
import { useEnv } from "../../utils/hooks/useEnv";

export const IframeFooter = () => {
	const searchParams = new URLSearchParams(location.search);
	const target = React.useRef(null);
	const size = useSize(target);
	const { footerEntryId } = useEnv();

	const vendor = searchParams.get("vendor") || undefined;

	const { locale, setLocale, localeCase } = useLocale();
	const lng = searchParams.get("lng");
	if (lng) {
		setLocale(lng === "en-CA" ? "en-US" : lng);
	}

	const { getFooterContent } = useContentful();

	const [footer, setFooterState] = useState<FooterState>({
		menuItems: [],
		supportLinks: [],
		socials: {
			title: "",
			links: []
		},
		languageParams: [],
		legalDisclaimer: "",
		logo: {
			altText: "",
			imageUrl: "",
			imageWidth: 0,
			imageHeight: 0,
			href: ""
		}
	});

	const [events, setEvents] = useState<any[]>([]);

	window.addEventListener("message", (event) => {
		if (event.data.type !== "CHANGE_NAV_LINK_FOOTER") return;
		setEvents((prevState) => [...prevState, event]);
	});

	const setupParentUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const rawParentUrl = urlParams.get("parentUrl");
		const parentUrl = rawParentUrl ? decodeURIComponent(rawParentUrl) : null;
		(window as any).iframeConfig = { parentUrl: parentUrl };
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", setupParentUrl);
	} else {
		setupParentUrl();
	}

	useEffect(() => {
		document.documentElement.style.overflow = "hidden";
	});

	useEffect(() => {
		events.forEach((event) => {
			const link = document.getElementById(
				"footer-" + event.data.linkId
			) as HTMLAnchorElement;
			if (link) {
				link.href = event.data.href;
			}

			const mobileLink = document.getElementById(
				"footer-" + event.data.linkId + "-mobile"
			) as HTMLAnchorElement;
			if (mobileLink) {
				mobileLink.href = event.data.href;
			}
		});
	});

	useEffect(() => {
		if (footerEntryId) {
			getFooterContent(footerEntryId, locale, vendor, localeCase).then(
				(footerValues) => {
					if (footerValues) {
						setFooterState({
							menuItems: footerValues.menuItems,
							socials: footerValues.socials,
							logo: footerValues.logo,
							legalDisclaimer: footerValues.legalDisclaimer,
							legalDisclaimerNode: footerValues.legalDisclaimerNode,
							supportLinks: footerValues.supportLinks,
							languageParams: footerValues.languageParams
						});
					}
				}
			);
		} else {
			// eslint-disable-next-line no-console
			console.error("[Footer]: Entry id not present");
		}
	}, [locale, footerEntryId]);

	useEffect(() => {
		window.parent.postMessage(
			{
				event: "STAPLES_IFRAME_FOOTER_SIZE_CHANGE",
				width: size?.width,
				height: size?.height
			},
			"*"
		);
	}, [size]);

	const footerItemClicked = (item: any) => {
		trackItem(item, "footer");
	};

	return (
		<>
			<Footer
				ref={target}
				externalLinks={footer.supportLinks}
				linkGroups={footer.menuItems}
				brandLogo={footer.logo}
				socials={footer.socials}
				legalese={footer.legalDisclaimer}
				legaleseNode={footer.legalDisclaimerNode}
				languageParams={footer.languageParams}
				footerVisibility={FooterMock.footerVisibility}
				itemClicked={footerItemClicked}
			/>
		</>
	);
};
